import React from 'react';

const MockDashboard: React.FC = () => {
  return (
    <div className="p-4 bg-gray-50 min-h-full">
      {/* Header */}
      <div className="mb-4">
        <h1 className="text-lg font-bold text-gray-900">Welcome back, John!</h1>
        <p className="text-sm text-gray-600">ReserveFlow Dashboard</p>
      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-2 gap-3 mb-4">
        {/* Calendar Card */}
        <div className="bg-white rounded-lg p-3 shadow-sm">
          <div className="flex items-center mb-2">
            <div className="w-6 h-6 bg-blue-100 rounded flex items-center justify-center mr-2">
              <svg className="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <span className="text-sm font-medium">Calendar</span>
          </div>
          <p className="text-xs text-gray-500">View reservations</p>
          <p className="text-xs text-blue-600 mt-1">Go to Calendar &rarr;</p>
        </div>

        {/* Stats Card */}
        <div className="bg-white rounded-lg p-3 shadow-sm">
          <div className="flex items-center mb-2">
            <div className="w-6 h-6 bg-green-100 rounded flex items-center justify-center mr-2">
              <svg className="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <span className="text-sm font-medium">Stats</span>
          </div>
          <div className="space-y-1 text-xs">
            <div className="flex justify-between">
              <span className="text-gray-500">Active:</span>
              <span className="text-green-600 font-medium">2</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-500">Upcoming:</span>
              <span className="text-blue-600 font-medium">5</span>
            </div>
          </div>
        </div>
      </div>

      {/* Upcoming Reservations */}
      <div className="bg-white rounded-lg p-3 shadow-sm mb-4">
        <h3 className="text-sm font-medium text-gray-900 mb-2">Upcoming Reservations</h3>
        <div className="space-y-2">
          <div className="flex items-center justify-between p-2 bg-gray-50 rounded text-xs">
            <div>
              <p className="font-medium text-gray-900">Team Meeting</p>
              <p className="text-gray-500">Jan 15, 2:00 PM</p>
            </div>
            <span className="text-blue-600">View</span>
          </div>
          <div className="flex items-center justify-between p-2 bg-gray-50 rounded text-xs">
            <div>
              <p className="font-medium text-gray-900">Conference Room</p>
              <p className="text-gray-500">Jan 16, 10:00 AM</p>
            </div>
            <span className="text-blue-600">View</span>
          </div>
        </div>
      </div>

      {/* Account Section */}
      <div className="bg-white rounded-lg p-3 shadow-sm">
        <h3 className="text-sm font-medium text-gray-900 mb-2">Account</h3>
        <div className="flex gap-2">
          <button className="text-xs px-2 py-1 bg-gray-100 text-gray-700 rounded">
            Change Password
          </button>
          <button className="text-xs px-2 py-1 bg-purple-100 text-purple-700 rounded">
            Subscriptions
          </button>
        </div>
      </div>
    </div>
  );
};

export default MockDashboard;
